import _ from 'lodash'

const popularPosts = (state) => _.get(state, 'popularPosts')
const isPopularPostsLoading = (state) => _.get(state, 'popularPostsLoading')

const popularPostsPreview = (state) => _.get(state, 'popularPostsPreview')
const isPopularPostsPreviewLoading = (state) => _.get(state, 'popularPostsPreviewLoading')

const isPopularPostsByCategoryLoading = (state) => _.get(state, 'popularPostsByCategoryLoading')
const popularPostsByCategory = (state) => _.get(state, 'popularPostsByCategory')

const errors = (state) => _.get(state, 'errors')
const total = (state) => _.get(state, 'total')

const isLoading = (state) => _.get(state, 'loading')

export default {
	popularPosts,
	isPopularPostsLoading,
	popularPostsPreview,
	isPopularPostsPreviewLoading,
	popularPostsByCategory,
	isPopularPostsByCategoryLoading,
	errors,
	total,
	isLoading,
}
